import isNil from 'lodash/isNil';
import {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';
import {CardSection as CardSectionType} from '../../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonSectionProps} from '../../type';

export function CardSection({section, children}: CommonSectionProps) {
  const {ref, inView, entry} = useInView();
  const cardSection = section as Omit<CardSectionType, 'groups'>;
  const isRecommendedItems = cardSection.isRecommendedItems;

  useEffect(() => {
    if (inView && entry?.target) {
      aggregateAndSendLog({
        targetElem: entry.target as HTMLElement,
        actionType: 'ViewImp',
        actionName: '섹션_노출',
        customProps: {
          user_action: 'imp',
          ...(!isNil(isRecommendedItems) && {
            helix_yn: isRecommendedItems ? 'y' : 'n',
          }),
        },
        viewimp_contents: {
          imp_provider: 'service',
          imp_type: 'vimp',
        },
      });
    }
  }, [entry, inView, isRecommendedItems]);

  return (
    <div
      ref={ref}
      {...putTiaraObjectProps({
        click: {
          layer1: '카드',
          imp_id: 'scard',
          imp_provider: 'service',
        },
        viewimp_contents: {
          imp_id: 'scard',
          layer1: '카드',
          imp_provider: 'service',
          imp_type: 'vimp',
        },
        customProps: {
          section_type: '카드',
          ...(!isNil(isRecommendedItems) && {
            helix_yn: isRecommendedItems ? 'y' : 'n',
          }),
        },
      })}
    >
      <div>{children}</div>
    </div>
  );
}
